import get from "lodash/get"

export const selectSelectedTheme = state => get(state, "selectedTheme")
export const selectSelectedLanguage = state => get(state, "selectedLanguage")
